// import Highcharts from 'highcharts'
// import noDataInit from 'highcharts/modules/no-data-to-display'
import store from '@/store'

function handleExtremes (chart, e) {
  const categories = chart.xAxis?.[0]?.categories

  const minIndex = Math.round(e.min)
  const maxIndex = Math.round(e.max)

  const total = chart.series
    .flatMap((s) =>
      s.data.slice(minIndex, maxIndex + 1).map((point) => point.y)
    )
    .reduce((sum, value) => sum + value, 0)

  store.commit('projectEnergy/SET_CHART_SUMMARY', {
    timeRange: `${categories[minIndex]} ~ ${categories[maxIndex]}`,
    total: Math.round(total * 100) / 100
    // isReset: false
  })
}

// noDataInit(Highcharts)
const commonSettings = {
  credits: { enabled: false },
  title: { text: '' },
  subtitle: { text: '' },
  legend: { enabled: false }
  // lang: {
  //   noData: '尚無資料'
  // },
}

const fontFamily =
  'Arimo, "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", "Microsoft YaHei", Montserrat,"Lantinghei TC", "Helvetica Neue", Helvetica, Arial, "sans-serif", serif'

const labels = {
  style: {
    fontWeight: 400,
    fontSize: '13px',
    fontFamily,
    color: '#626262'
  }
}

const colors = [
  '#4b80a8',
  '#81C7D3',
  '#DED1BE',
  '#8BA95E',
  '#DCB840',
  '#EF8557',
  '#747474',
  '#7F77B0',
  '#C584BC',
  '#E45947'
]

// --------------------------- 用電 ---------------------------
// ------------------------------------------------------------

// const pieColors = () => {
//   const colors = []
//   // var base = Highcharts.getOptions().colors[0]
//   // const base = '#8de9f7'
//   const base = '#72d7fc'

//   for (let i = 0; i <script 10; i += 1) {
//     // Start out with a darkened base color (negative brighten), and end
//     // up with a much brighter color
//     colors.push(
//       Highcharts.color(base)
//         .brighten((i - 3) / 7)
//         .get()
//     )
//   }
//   return colors
// }

export const pieChartSettings = {
  ...commonSettings,

  chart: {
    type: 'pie',
    height: 420,
    spacingBottom: 20,
    marginBottom: 70
  },

  subtitle: {
    text: '',
    style: {
      color: '#4B80A8',
      fontSize: '16px',
      fontWeight: 500,
      fontFamily:
        'Arimo, "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", "Microsoft YaHei", Montserrat,"Lantinghei TC", "Helvetica Neue", Helvetica, Arial, "sans-serif", serif'
    },
    verticalAlign: 'middle',
    // y: 83
    useHTML: true
  },
  tooltip: {
    style: {
      color: '#414141',
      fontSize: '14px',
      fontWeight: 'bold'
    },
    // valueSuffix: ' %', // pointFormat 有 point.y 才會出現
    hideDelay: 0,
    padding: 15,
    useHTML: true,
    headerFormat: '<div class="mb-1 font-weight-normal">{point.key}</div>',
    pointFormat:
      '<span style="color:{point.color}">\u25CF</span> <b style="letter-spacing: 0.5px">{series.name}: </b> <b style="color: #2b2b2b">{point.value:.2f}</b><span> kWh</span>'
  },
  colors,
  legend: {
    // layout: 'vertical',
    // align: 'right',
    // verticalAlign: 'top',
    // x: -60
    // y: 50
    // itemDistance: 80
    // floating: true
    // margin: -150,
    // itemMarginTop: 10,
    // itemPaddingTop: 18,

    // symbolWidth: 16,
    // symbolHeight: 16,
    itemDistance: 8,
    itemStyle: {
      color: '#4b80a8',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '10px'
    }
    // symbolRadius: 6
  },
  plotOptions: {
    pie: {
      // allowPointSelect: false,
      // cursor: 'pointer',
      // colors: pieColors(),

      borderWidth: 0, // 柱邊框

      // size: '90%', // chart size
      innerSize: '56%',
      showInLegend: true,
      dataLabels: {
        enabled: true,
        format: '<span>{point.percentage:.1f} %</span>',
        // format:
        //   '<span>{point.name}</span><br><span style="font-size: 1.2em">{point.percentage:.1f} %</span>',
        distance: -40,
        filter: {
          property: 'percentage',
          operator: '>',
          value: 4 // 大於才顯示 label
        },
        // style: {
        //   color: 'red',
        //   backgroundColor: 'white'
        // }
        style: {
          textOutline: 'none', // 移除文字白邊
          color: '#fff', // 設定文字顏色
          fontSize: '16px', // 自訂文字大小
          fontWeight: 'normal',
          fontFamily
        }
        // backgroundColor: 'rgba(255, 255, 255, 0.8)', // 背景顏色 (半透明白色)
        // borderRadius: 3, // 圓角邊框
        // paddingTop: 2, // 內邊距
        // paddingBottom: 0
      },

      stickyTracking: false,
      states: {
        hover: {
          brightness: 0,
          halo: {
            // 外暈光樣式
            size: 0
            // opacity: 0.8
          }
        },
        normal: {
          animation: {
            duration: 200
            // 反白變至正常的動畫時間
          }
        }
        // inactive: {
        //   enabled: false // 滑鼠移至圖表某類時，其他類不變淡
        // }
      }
    }
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          subtitle: {
            y: -3
          },
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
            x: 0,
            y: 0,
            margin: 0,
            itemMarginBottom: 10
          }
        }
      }
    ]
  }
}

export const lineColumnChartSettings = {
  ...commonSettings,

  chart: {
    type: 'column',
    height: 260,
    // marginTop: 65,
    zooming: {
      type: 'xy'
    },
    events: {
      load: function () {
        handleExtremes(this, this.xAxis?.[0]?.getExtremes())
      }
    }
  },

  // noData: {
  //   style: {
  //     fontWeight: 'bold',
  //     fontSize: '15px',
  //     color: '#303030'
  //   }
  // },
  title: {
    text: '',
    align: 'left',
    style: {
      color: '#4b80a8',
      fontSize: '24px',
      fontWeight: 700,
      letterSpacing: '1.2px',
      fontFamily
    }
  },
  tooltip: {
    style: {
      color: '#414141',
      fontSize: '14px',
      fontWeight: 'bold'
    },
    shared: true,
    valueSuffix: ' kWh',
    distance: 30,
    // followPointer: true, // 跟隨滑鼠
    hideDelay: 0,
    padding: 15,
    useHTML: true,
    headerFormat: '<div class="mb-1 font-weight-normal">{point.key}</div>',
    pointFormat:
      '<span style="color:{point.color}">\u25CF</span> <b style="letter-spacing: 0.5px">{series.name}: </b> <b style="color:{point.color};filter: brightness(80%)">{point.y}</b><br/>'
  },
  xAxis: {
    crosshair: true,
    // categories: Array.from(
    //   { length: 31 },
    //   (_, idx) => `12/${String(idx + 1).padStart(2, '0')}`
    // ),
    labels: {
      ...labels,
      formatter: function () {
        // 這裡的 this.value 就是 categories[i]
        const isChooseHourAndMoreThanOneDay = this.value?.length === 16 // 時間格式為 '2022-01-01 00:00'
        if (isChooseHourAndMoreThanOneDay) {
          const splitValue = this.value.split(' ')
          if (splitValue[1] === '00:00') {
            // 整點 取日期
            return splitValue[0]
          } else {
            return splitValue[1]
          }
        }
        return this.value
      }
    },
    events: {
      afterSetExtremes: function (e) {
        handleExtremes(this.chart, e)
      }

      // 縮放 zooming 或平移 panning 後，X 軸的新範圍
      // e.min 新的 X 軸最小值, e.max 新的 X 軸最大值
      // afterSetExtremes: function (e) {
      //   const minIndex = Math.round(e.min)
      //   const maxIndex = Math.round(e.max)
      //   // console.log('afterSetExtremes', minIndex, maxIndex)
      //   // const visibleData = {}
      //   // console.log('categories', this.categories)
      //   // console.log('series', this.chart.series)
      //   // this.chart.series.forEach((s) => {
      //   //   visibleData[s.name] = s.data
      //   //     .slice(minIndex, maxIndex + 1)
      //   //     .map((point) => ({
      //   //       time: this.categories[point.x],
      //   //       value: point.y,
      //   //       x: point.x
      //   //     }))
      //   // })
      //   // console.log('目前視窗內的資料：', visibleData)
      //   // const total = Object.values(visibleData)
      //   //   .flat()
      //   //   .reduce((sum, p) => sum + p.value, 0)

      //   // 直接計算 total
      //   const total = this.chart.series
      //     .flatMap((s) =>
      //       s.data.slice(minIndex, maxIndex + 1).map((point) => point.y) // data.slice  等同視窗範圍
      //       // s.points.map((point) => point.y) // points 根據視窗範圍重新計算, 但有時因 boost 沒變化
      //     )
      //     .reduce((sum, value) => sum + value, 0)
      //   // console.log(this.chart, maxIndex - minIndex + 1)

      //   // 只有 zooming 才顯示
      //   // if (this.chart.xAxis?.[0].categories?.length === maxIndex - minIndex + 1) {
      //   //   store.commit('projectEnergy/SET_CHART_SUMMARY_IS_RESET', true)
      //   // } else {
      //   //   store.commit('projectEnergy/SET_CHART_SUMMARY', {
      //   //     timeRange: `${this.categories[minIndex]} ~ ${this.categories[maxIndex]}`,
      //   //     total: Math.round(total * 100) / 100,
      //   //     isReset: false
      //   //   })
      //   // }

      //   store.commit('projectEnergy/SET_CHART_SUMMARY', {
      //     timeRange: `${this.categories[minIndex]} ~ ${this.categories[maxIndex]}`,
      //     total: Math.round(total * 100) / 100,
      //     isReset: false
      //   })
      // }
    }
  },
  yAxis: {
    title: {
      text: '',
      // text: '用電歷史（kWh）',
      // offset: 50,
      rotation: 0,
      x: 66,
      style: {
        fontSize: '0.8rem',
        verticalAlign: 'middle',
        writingMode: 'vertical-rl',
        '-webkit-writing-mode': 'vertical-rl',
        '-ms-writing-mode': 'tb-rl'
      }
    },
    labels
  },
  colors,
  plotOptions: {
    line: {
      marker: {
        enabled: false // 線上無圓點
      },
      stickyTracking: false,
      states: {
        hover: {
          enabled: false // 不產生圓點
        }
      }
    },
    column: {
      borderWidth: 0, // 柱邊框
      // pointWidth: 20, // 柱寬 固定的話寬度縮小會擠在一起
      // maxPointWidth: 150,
      // groupPadding: 0.045, // 組與組之間的小間隙（群組間）
      // pointPadding: 0.045, // 同一組柱子中，柱子與柱子的小間隙

      // stickyTracking: false, // 是否自動抓取最近的顯示
      states: {
        hover: {
          brightness: 0.2
        },
        inactive: {
          enabled: false // 滑鼠移至圖表某類時，其他類不變淡
        }
      }
    }
  },
  legend: {
    // align: 'right',
    // verticalAlign: 'top',
    // x: -10,
    // y: -5,
    // floating: true,

    // symbolWidth: 16,
    // symbolHeight: 16,
    itemDistance: 8,
    itemStyle: {
      color: '#626262',
      fontWeight: 'normal',
      fontSize: '12px'
    }
  }
  // responsive: {
  //   rules: [{
  //     condition: {
  //       maxWidth: 800
  //     },
  //     chartOptions: {
  //       plotOptions: {
  //         column: {
  //           // maxPointWidth: 20
  //           pointWidth: undefined // 柱寬回復預設
  //         }
  //       }
  //     }
  //   }]
  // }
}

// --------------------------- 綠電 ---------------------------
// ------------------------------------------------------------
export const greenChartSettings = {
  ...commonSettings,

  chart: {
    height: 350,
    marginTop: 80
  },

  title: {
    text: '綠電佔比趨勢',
    align: 'left',
    style: {
      color: '#4b80a8',
      fontSize: '32px',
      fontWeight: 700,
      letterSpacing: '1.2px',
      fontFamily
    }
  },
  tooltip: {
    // backgroundColor: '#ffffff', // 完全不透明的白色背景
    style: {
      color: '#414141',
      fontSize: '14px',
      fontWeight: 'bold'
    },
    shared: true,
    valueSuffix: ' kWh',
    distance: 30,
    followPointer: true,
    hideDelay: 0,
    padding: 15,
    useHTML: true,
    headerFormat: '<div class="mb-1 font-weight-normal">{point.key}</div>',
    pointFormat:
      '<span style="color:{point.color}">\u25CF</span> <b style="letter-spacing: 0.5px">{series.name}: </b> <b style="color:{point.color};filter: brightness(80%)">{point.y}</b><br/>'
  },
  xAxis: {
    // offset: 10, // x軸上方空間,
    crosshair: true,
    tickWidth: 1, // 刻度

    // categories: Array.from(
    //   { length: 31 },
    //   (_, idx) => `12/${String(idx + 1).padStart(2, '0')}`
    // ),
    labels
  },
  yAxis: {
    title: {
      text: '',
      // text: '電量（度）',
      rotation: 0,
      x: 35,
      style: {
        fontSize: '0.8rem',
        verticalAlign: 'middle',
        writingMode: 'vertical-rl',
        '-webkit-writing-mode': 'vertical-rl',
        '-ms-writing-mode': 'tb-rl'
      }
    },
    labels,
    reversedStacks: false
  },
  colors: ['#4b80a8', '#ebe4da', '#c6d281'],
  plotOptions: {
    line: {
      marker: {
        // enabled: false // 線上無圓點
      },
      stickyTracking: false,
      states: {
        hover: {
          // enabled: false // 不產生圓點
        }
      }
    },
    column: {
      stacking: 'normal',

      borderWidth: 0, // 柱邊框
      // pointWidth: 40, // 柱寬 固定的話寬度縮小會擠在一起
      groupPadding: 0.045, // 組與組之間的小間隙（群組間）
      pointPadding: 0.045, // 同一組柱子中，柱子與柱子的小間隙

      stickyTracking: false,
      states: {
        hover: {
          // brightness: 0.2
        },
        inactive: {
          // enabled: false // 滑鼠移至圖表某類時，其他類不變淡
        }
      }
    }
  },
  legend: {
    align: 'right',
    verticalAlign: 'top',
    // x: -10,
    y: 0,
    floating: true,

    // symbolWidth: 22,
    // symbolHeight: 22,
    itemStyle: {
      color: '#626262',
      fontWeight: 'normal',
      fontSize: '15px',
      fontFamily,
      height: '35px',
      verticalAlign: 'top'
    }
    // itemHoverStyle: {
    //   color: '#4b80a8'
    // }
  }
}

// ------------------------- 發電用電-------------------------
// ----------------------------------------------------------
export const powerChartSettings = {
  ...commonSettings,

  chart: {
    type: 'spline',
    height: 400,
    marginTop: 100
  },

  title: {
    text: '發電用電趨勢',
    align: 'left',
    style: {
      color: '#4b80a8',
      fontSize: '32px',
      fontWeight: 500,
      letterSpacing: '1.2px',
      fontFamily
    }
  },
  tooltip: {
    // backgroundColor: '#ffffff', // 完全不透明的白色背景
    style: {
      color: '#414141',
      fontSize: '14px',
      fontWeight: 'bold'
    },
    shared: true,
    valueSuffix: ' kWh',
    distance: 30,
    followPointer: true,
    hideDelay: 0,
    padding: 15,
    useHTML: true,
    // headerFormat: '<div class="mb-1 font-weight-normal">{point.key}</div>',
    // pointFormat:
    //   '<span style="color:{point.color}">\u25CF</span> <b style="letter-spacing: 0.5px">{series.name}: </b> <b style="color:{point.color}">{point.y}</b><br/>',
    // footerFormat: '<div class="mb-1 font-weight-normal">{point.key}</div>'

    // TODO: 加總發電量

    formatter: function () {
      // console.log(this.points)
      const title = `<div class="font-weight-normal">${this.points[0].key}</div>`

      // const list = this.points.reduce((accu, curr, idx) => {
      //   console.log(accu, curr)
      //   if (curr.series.name === '綠電自發自用' || curr.series.name === '餘電躉售') {
      //     return accu + curr.y
      //   }
      //   return accu
      // }, 0)
      // console.log(list)

      // return list + ''

      const list = this.points.reduce((s, point) => {
        // console.log(s, point)
        return (
          s +
          `<span style="color:${point.color}">\u25CF</span> <b style="letter-spacing: 0.5px">${point.series.name}: </b><b style="color:${point.color};filter: brightness(90%)">${point.y}</b> <span style="font-size: 0.9em">kWh</span><br/>`
        )
      }, '')

      const totalPower = this.points.reduce((accu, curr, idx) => {
        // console.log(accu, curr)
        if (
          curr.series.name === '綠電自發自用' ||
          curr.series.name === '餘電躉售'
        ) {
          return accu + curr.y
        }
        return accu
      }, 0)

      const totalPowerText = `( 發電量: ${
        Math.round(totalPower * 100) / 100
      }<span style="font-size: 0.9em"> kWh</span> )`

      return title + list + totalPowerText
    }
  },
  xAxis: {
    offset: 10, // x軸上方空間,
    // crosshair: true,
    tickmarkPlacement: 'on', // 將刻度標記對齊資料點
    crosshair: {
      color: '#ddd', // 設置線條的顏色
      width: 1, // 線條寬度
      dashStyle: 'Solid', // 線條樣式
      zIndex: 3
    },
    tickWidth: 2, // 刻度
    tickLength: 20,
    tickColor: '#dbdbdb',
    lineWidth: 2,
    lineColor: '#dbdbdb',

    // categories: Array.from(
    //   { length: 24 },
    //   (_, idx) => `${String(idx + 1).padStart(2, '0')}:00`
    // ),
    labels: {
      ...labels,
      y: 35
    }
    // plotBands: [{
    //   from: 5,
    //   to: 9,
    //   color: '#565',
    //   label: {
    //     text: '夜間',
    //     style: {
    //       color: '#56552'
    //     }
    //   }
    // }]
  },
  yAxis: {
    title: {
      text: '',
      // text: '電量（度）',
      rotation: 0,
      x: 35,
      style: {
        fontSize: '0.8rem',
        verticalAlign: 'middle',
        writingMode: 'vertical-rl',
        '-webkit-writing-mode': 'vertical-rl',
        '-ms-writing-mode': 'tb-rl'
      }
    },
    gridLineWidth: 2,
    gridLineColor: '#dbdbdb',
    // tickInterval: 25, // y 軸刻度間距
    labels
  },
  colors: ['#4b80a8', '#dcb840', '#c6d281'],
  plotOptions: {
    spline: {
      // fillOpacity: 0.4,
      clip: false,
      marker: {
        enabled: false, // 不顯示線上的點
        symbol: 'circle', // 統一圓形
        radius: 4 // hover 顯示的點大小
        // states: {
        //   hover: {
        //     enabled: true
        //   }
        // }
      },
      lineWidth: 3,
      // trackByArea: true,
      stickyTracking: false,
      states: {
        inactive: {
          enabled: false // 滑鼠移至圖表某類時，其他類不變淡
        }
      }
    }
  },
  legend: {
    align: 'right',
    verticalAlign: 'top',
    // x: -10,
    y: 0,
    floating: true,
    // symbolWidth: 22,
    // symbolHeight: 22,
    itemStyle: {
      color: '#626262',
      fontWeight: 'normal',
      fontSize: '15px',
      fontFamily,
      height: '35px',
      verticalAlign: 'top'
    }
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 570
        },
        chartOptions: {
          title: {
            // text: "發電用電趨勢",
            align: 'center',
            style: {
              // color: '#4b80a8',
              fontSize: '20px'
              // fontWeight: 500,
              // letterSpacing: "1.2px",
              // fontFamily,
            }
          },
          legend: {
            align: 'center',
            y: 30
            // verticalAlign: 'bottom',
            // layout: 'horizontal'
          }
        }
      }
    ]
  }
}

export const halfPieChartSettings = {
  ...commonSettings,

  chart: {
    type: 'pie',
    backgroundColor: 'transparent',
    // plotBackgroundColor: 'red',
    height: 1, // <-> 依據高度前端計算後給值
    margin: [0, 0, 0, 0],
    spacing: [0, 0, 0, 0]
  },

  tooltip: {
    enabled: false // 不顯示 pie tooltip
    // style: {
    //   color: '#414141',
    //   fontSize: '14px',
    //   fontWeight: 'bold'
    // },
    // hideDelay: 0,
    // padding: 15,
    // useHTML: true,
    // headerFormat: '<div class="mb-1 font-weight-normal">{point.key}</div>',
    // pointFormat:
    //   '<span style="color:{point.color}">\u25CF</span> <b style="letter-spacing: 0.5px">{series.name}: </b> <b style="color: #2b2b2b">{point.value:.2f}</b><span> kWh</span>'
  },
  colors: ['#aadaff', '#ebe4da'],
  plotOptions: {
    pie: {
      startAngle: -90, // 起始角度 為呈半圓
      endAngle: 90,

      borderWidth: 0,

      size: '100%', // chart 直徑 (用 'xx%' 或 固定數值 皆可，但 % 會自動留一些空間) // <-> 依據高度前端計算後給值
      // center: ['50%', '103%'],
      center: ['50%', '50%'], // chart 中心 x, y (用 'xx%' 或 固定數值 皆可) // <-> 依據高度前端計算後給值
      innerSize: '45%', // chart 內圓
      showInLegend: true,
      dataLabels: {
        enabled: true,
        format: '{point.y:.1f}%', // **確保小數點 1 位，整數不顯示 .0**
        // format: '<span>{point.percentage:.1f}123%</span>',
        // format: '<span>{point.name}</span><br><span style="font-size: 1.2em">{point.percentage:.1f} %</span>',
        distance: '-26%', // chart 上文字距離
        crop: false, // 不要裁切 ex 數字超出會變 2...
        overflow: 'allow', // 允許超出範圍

        style: {
          textOutline: '1.5px #fff', // 移除文字白邊 'none'
          color: '#4b80a8', // 設定文字顏色
          fontSize: '16px', // 自訂文字大小
          fontWeight: 'normal',
          fontFamily
        }
        // backgroundColor: 'rgba(255, 255, 255, 0.8)', // 背景顏色 (半透明白色)
        // borderRadius: 3, // 圓角邊框
        // paddingTop: 2, // 內邊距
        // paddingBottom: 0
      },

      stickyTracking: false,
      states: {
        hover: {
          brightness: 0,
          halo: {
            // 外暈光樣式
            size: 0
            // opacity: 0.8
          }
        },
        normal: {
          animation: {
            duration: 200
            // 反白變至正常的動畫時間
          }
        },
        inactive: {
          enabled: false // 滑鼠移至圖表某類時，其他類不變淡
        }
      }
    }
  }
}
